<script>
import Loader from "@/components/widgets/loader";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import addedit from "./addedit";
import okurumgorusme from "@/models/okurumgorusme";
import treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";
export default {
  mixins: [Api, Sabit, okurumgorusme],
  page: {
    title: "Kurum Görüşmeleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    addedit, treeselect
  },
  data() {
    return {
      title: "Kurum Görüşmeleri",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Kurum Görüşmeleri",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: 1,
        PageSize: 10,
        PageDataSize: 1,
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      loading: true,
      FILES_URL: JSON.parse(localStorage.getItem("config")).FILES_URL,
      Filter: {
        Birimid: null,
        Gorusulenkisi: "",
      },
    };
  },

  methods: {
    Get() {

      var FilterText = "&Desc=Tarih"

      if (this.Filter.Birimid != null && this.Filter.Birimid != "") {
        FilterText += "&Birimid=" + this.Filter.Birimid
      }

      if (this.Filter.Gorusulenkisi != null && this.Filter.Gorusulenkisi != "" &&
        typeof this.Filter.Gorusulenkisi === "string" && this.Filter.Gorusulenkisi.length > 2) {
        FilterText += "&Gorusulenkisi=" + this.Filter.Gorusulenkisi
      }

      this.ActionsFilterGet({
        Service: "okurumgorusme",
        Page: this.Page,
        Filter: FilterText,
      }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
        this.loading = false;
      });
    },
    ModulListe(modul) {
      return modul ? modul.split(",").map((m) => m.trim()).filter(Boolean) : [];
    },
  },
};
</script>

<template>
  <Loader :loading="loading">
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">

                <div class="col-sm-8 row">

                  <b-form-group class="col-lg-3" label-for="text" label="Kurum" :key="Filter.Birimid">
                    <treeselect :multiple="false" :options="FormDataType.Birimid.ComboDataArray"
                      placeholder="Seçiniz..." v-model="Filter.Birimid" />
                    <treeselect-value :value="Filter.Birimid" />
                  </b-form-group>

                  <b-form-group class="col-lg-3" label="Görüşülen Kişi">
                    <b-form-input v-model="Filter.Gorusulenkisi" type="text"></b-form-input>
                  </b-form-group>

                  <div class="col-lg-3 mt-4">
                    <button class="btn btn-success  " data-bs-dismiss="offcanvas" type="button" data-bs-target="#demo"
                      @click="Page.PageNumber = 1, Get()">
                      Filtreleme
                    </button>
                  </div>

                </div>
                <div class="col-sm-4">
                  <div class="text-sm-end">

                    <button
                      type="button"
                      class="btn btn-primary btn-rounded mb-2 me-2"
                      v-b-modal.okurumgorusme
                      @click="(DataUpdate = okurumgorusmeData), (AddEdit = 'Add')"
                    >
                      <i class="mdi mdi-plus me-1"></i>
                      Yeni Kayıt Ekle
                    </button>

                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Kurum</th>
                      <th>Tarih</th>
                      <th>Görüşme Şekli</th>
                      <th>Modül</th>
                      <th>Görüşme Notu</th>
                      <th class="text-center">İşlem</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">
                        {{ Data.Birimadi }}
                        <div class="sub-text" v-if="Data.Gorusulenkisi">Görüşülen Kişi: {{ Data.Gorusulenkisi }}</div>
                      </th>
                      <td>
                        {{ formatDateTable(Data.Tarih) }}
                        <div class="sub-text" v-if="Data.Sonrakiadimtarihi">Sonraki Adım: {{ formatDateTable(Data.Sonrakiadimtarihi) }}</div>
                      </td>
                      <td>
                        {{ Data.Gorusmesekliadi }}
                      </td>
                      <td>
                        <div class="module-chip-wrap">
                          <span class="badge module-badge" v-for="(m, idx) in ModulListe(Data.Modul).slice(0, 2)" :key="idx">{{ m }}</span>
                          <span
                            class="badge module-badge module-badge-more"
                            v-if="ModulListe(Data.Modul).length > 2"
                            v-b-tooltip.hover
                            :title="ModulListe(Data.Modul).slice(2).join(', ')"
                          >+{{ ModulListe(Data.Modul).length - 2 }}</span>
                        </div>
                      </td>
                      <td>
                        <div class="note-cell-full">
                        <a
                          target="_blank"
                          :href="FILES_URL + '/Tlp/' + Data.Dosyayolu"
                          v-if="Data.Dosyayolu"
                          v-b-tooltip.hover
                          title="Belgeyi Görüntüle"
                          class="belge-link"
                        >
                          <i class="mdi mdi-paperclip"></i>
                        </a>{{ Data.Aciklama }}</div>
                      </td>
                      <td>
                        <div
                          class="
                            action-is
                            w-100
                            d-flex
                            justify-content-center
                            align-items-center
                          "
                        >
                          <b-button-group>
                            <b-button
                              v-b-tooltip.hover
                              title="Düzenle"
                              variant="success"
                              v-b-modal.okurumgorusme
                              @click="(DataUpdate = Data), (AddEdit = 'Edit')"
                              ><i class="far fa-edit"></i
                            ></b-button>
                            <b-button
                              variant="danger"
                              v-b-tooltip.hover
                              title="Sil"
                              @click="Delete('okurumgorusme', Data.Id)"
                              ><i class="far fa-trash-alt"></i
                            ></b-button>
                          </b-button-group>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination
                  class="pagination pagination-rounded justify-content-end mb-2"
                  v-model="DefaultPage"
                  :total-rows="Page.PageDataSize"
                  :per-page="Page.PageSize"
                  aria-controls="my-table"
                  @page-click="ChangePage($event, (Page.PageDataSize / Page.PageSize))"
                >
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <addedit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" />
    </Layout>
  </Loader>
</template>

<style scoped>
.sub-text {
  margin-top: 2px;
  font-size: 12px;
  font-weight: 400;
  color: #74788d;
}

.module-chip-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  max-width: 220px;
}

.module-badge {
  background-color: #eff2f7;
  color: #495057;
  font-weight: 500;
  font-size: 11px;
  white-space: normal;
  text-align: left;
}

.module-badge-more {
  background-color: #556ee6;
  color: #fff;
  cursor: default;
}

.note-cell-full {
  min-width: 260px;
  white-space: normal;
  word-break: break-word;
}

.belge-link {
  margin-left: 6px;
  font-size: 16px;
  color: #556ee6;
}

.belge-link:hover {
  color: #34495e;
}
</style>
